/**
 * Hand a blob to the browser as a file download, through a transient
 * object URL (the same approach as `downloadCsv` and the document viewer).
 */
export function saveBlob(fileName: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
